"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _font = _interopRequireDefault(require("./font"));
var _color = _interopRequireDefault(require("./color"));
var headings = "\n  color: ".concat(_color.default.charcoal, ";\n  font-family: ").concat(_font.default.secondaryBold, ";\n");
var _default = exports.default = headings;